import React from "react";
import Alert from './Alert';
import _ from "lodash";

const SuccessMessageAlert = ({success, className}) => {
    const alertClassName = className !== undefined ? className : '';
    if (_.isEmpty(success)) {
        return '';
    }
    if (typeof success === 'string') {
        return (
          <Alert type="success" content={success} className={alertClassName} />
        );
    }
    if (Array.isArray(success)) {
        return (
          <Alert type="success" className={alertClassName}>
              <ul>
                  {success.map((item, index) => <li key={index}>{item}</li>)}
              </ul>
          </Alert>
        );
    }
    return '';
};

export default SuccessMessageAlert;